module.exports = __WEBPACK_EXTERNAL_MODULE_42__;


/*****************
 ** WEBPACK FOOTER
 ** external {"amd":"pubnub","commonjs":"pubnub","commonjs2":"pubnub","root":"PUBNUB"}
 ** module id = 42
 ** module chunks = 0
 **/